import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { OptionalOrNull } from "../shared-schemas";

const platformInfo = new SchemaValidator(
	Type.Object({
		platform: Type.Union([
			Type.Literal("none"),
			Type.Literal("lockdown"),
			Type.Literal("extension"),
			Type.Literal("mobile"),
		]),
		version: OptionalOrNull(Type.String()),
		versionSupported: Type.Boolean(),
	}),
);

const versionSupported = new SchemaValidator(
	Type.Object({
		versionSupported: Type.Boolean(),
	}),
);

export default {
	platformInfo,
	versionSupported,
};
